<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <div class="title is-3">Certificates</div>
      </div>
      <div class="column is-3">
        <div class="buttons">
          <b-button
            type="is-primary"
            icon-left="plus"
            expanded
            @click="$router.push({ name: 'certificates.create' })"
            >New Certificate</b-button
          >
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="secondary-border">
          <div class="columns secondary-border-bottom">
            <div class="column"><span class="title is-5">Title</span></div>
            <div class="column is-4"><span class="title is-5">ID</span></div>
            <div class="column is-2"></div>
          </div>
          <div
            class="columns secondary-border-bottom"
            v-for="(certificate, ID) in certificates"
            :key="ID"
          >
            <div class="column">
              <div>
                <b-tag type="is-light" v-if="certificate.Certificates">{{
                  certificate.Certificates.length
                }}</b-tag>
                {{ certificate.Title }}
              </div>
            </div>
            <div class="column is-4">
              <a
                @click="
                  $router.push({
                    name: 'certificates.edit',
                    params: { id: ID }
                  })
                "
                >{{ ID }}</a
              >
            </div>
            <div class="column is-2">
              <div class=" has-text-centered">
                <b-button
                  icon-left="content-copy"
                  class="mr-2"
                  v-clipboard:copy="
                    `https://media.dotronglong.com/certificates/${ID}`
                  "
                  v-clipboard:success="
                    () => $buefy.toast.open('URL is copied to clipboard')
                  "
                ></b-button>
                <b-button
                  type="is-danger"
                  icon-left="delete"
                  @click="remove(ID)"
                ></b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certificates: {},
      loader: null
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load(force = false) {
      this.$api.certificates
        .get(force)
        .then(certificates => (this.certificates = certificates));
    },
    remove(id) {
      if (!confirm("Are you sure?")) {
        return;
      }
      this.$api.certificates.remove(id).then(() => this.load(true));
    }
  }
};
</script>
